import { useState } from 'react';
import { updateUser } from '../../util/db';
import { handleEmail } from "../../util/email"
import { getAuth, updateEmail } from 'firebase/auth';
import { requireAuth } from '../../util/auth';
import ReauthModal from "../ReauthModal";

const EditInformationCard = (props) => {
  const [isEditing, setIsEditing] = useState(false)
  const [disabled, setDisabled] = useState(false)
  const [information, setInformation] = useState(props.informationArray)
  const [onLoadEmail, setOnLoadEmail] = useState(information[2].value)
  const [validateEmailMessage, setValidateEmailMessage] = useState("")
  const [reauthState, setReauthState] = useState({
    show: false,
  });

  async function handleEditClick() {
    if (isEditing && props.collection === "users") {
      setDisabled(true)
      let newEmail = information[2].value
      let res = await handleEmail("validateEmail", {
        "email": newEmail
      })
      if (!res.success) {
        setValidateEmailMessage(res.message)
        setDisabled(false)
        return
      }

      let oldEmails = information[5].value
      let oldEmailData
      if (oldEmails === null) {
        // if there haven't been any oldEmails so far: we need to either add the one email if it's the same or the old onLoadEmail and the new email
        oldEmailData = newEmail === onLoadEmail ? [newEmail] : [onLoadEmail, newEmail]
      } else {
        // otherwise: pass along the oldEmails or tack on the new one
        oldEmailData = newEmail === onLoadEmail ? oldEmails : [...oldEmails, newEmail]
      }

      // wait for popup modal to update the authentication if we are changing emails or only update the db
      if (onLoadEmail !== newEmail) {
        async function callFirebaseUpdateEmail() {
          let a = getAuth()
          const user = a.currentUser;
          await updateEmail(user, newEmail)
          await updateDBUser(newEmail, oldEmailData)
        }
        setReauthState({
          show: true,
          message: "Please enter your username and password to reauthenticate for this action.",
          callback: callFirebaseUpdateEmail,
        })
      } else {
        await updateDBUser(newEmail, oldEmailData)
      }

      setDisabled(false)
    }
    setIsEditing(!isEditing);
  };

  async function updateDBUser(newEmail, oldEmailData) {
    await updateUser(props.id, {
      name: information[0].value,
      company: information[1].value,
      email: newEmail,
      phone: information[3].value,
      role: information[4].value,
      oldEmails: oldEmailData,
    })
    setOnLoadEmail(newEmail)
  }

  const handleInputChange = (index, event) => {
    const newInformation = [...information];
    newInformation[index].value = event.target.value;
    setInformation(newInformation);
  };

  return (
    <div className="flex flex-col md:flex-row justify-between rounded-lg p-4 w-full border border-solid border-gray-200">
      {reauthState.show && (
        <ReauthModal
          callback={reauthState.callback}
          provider={"password"}
          onDone={() => setReauthState({ show: false })}
        >
          <h3 className="text-xl font-semibold mb-4">Enter your password to confirm changing email</h3>
          <ol className="list-decimal pl-6 space-y-2">
            <li><span className="font-semibold">Enter your current password</span> to continue.</li>
            <li>A verification link will be sent to your new email <span className="font-semibold">- click the link inside.</span></li>
            <li><span className="font-semibold">Sign in</span> again with your new email address.</li>
          </ol>
        </ReauthModal>
      )}
      <div className="flex flex-col items-left space-y-4">
        <h3 className="text-xl font-semibold">{props.title}</h3>
        {information.map((each, index) => (
          <div key={index}>
            {each.visible ? (
              <div>
                <p className='text-gray-400 text-sm'>{each.name}</p>
                {isEditing ? (
                  <input
                    type="text"
                    value={each.value}
                    onChange={(event) => handleInputChange(index, event)}
                    className="border border-gray-300 rounded p-1"
                  />
                ) : (
                  <p>{each.value}</p>
                )}
              </div>
            ) : (
              <div></div>
            )}
          </div>
        ))}
      </div>
      <div
        className='flex flex-col'
      >
        <button
          disabled={disabled}
          onClick={handleEditClick}
          className="items-right px-4 h-min py-2 bg-gray-white text-green-700 border border-solid border-green-600 rounded-md"
        >
          {isEditing ? 'Save Changes' : 'Edit Information'}
        </button>
        <p className="items-right text-sm md:text-sm text-center text-red-700">{validateEmailMessage}</p>
      </div>
    </div>
  );
};

export default requireAuth(EditInformationCard);
